var convertTitleToId = function(title) {
    return title.toLowerCase().replace(/\s/g, '-');
};

export { convertTitleToId };
